module.exports = __webpack_public_path__ + "img/2MFA.dc5b9719.png";